import { useTranslation } from "react-i18next";

import { QnASection } from "@app-components/faq/FaqSection";
import MTBreadcrumb from "@app-components/header/MTBreadcrumb";
import {
  CONTACT_EMAIL,
  DISPLAY_PHONE_NUMBER,
  PHONE_NUMBER,
} from "@app-constants/common";
import { preOrderPolicy } from "@app-constants/order";
import { getRoutes } from "@app-utils/routes";

export default function PreOrderPolicyPage() {
  const { t } = useTranslation();
  const routes = getRoutes(t);
  return (
    <div className="container faq faq-detail pre-order">
      <MTBreadcrumb items={[routes.home, routes.preOrder]} />
      <div className="faq-detail-container">
        <div className="wrapper">
          <div className="faq-detail-header">
            <div className="faq-detail-header-container">
              <div className="faq-detail-title">
                {t("title.preOrderPolicy")}
              </div>
              <div className="faq-detail-subtitle">
                {t("page.preOrder.subtitle")}
              </div>
            </div>
          </div>
          <QnASection item={preOrderPolicy} showHeader={false} />
          <div className="mt-text-body-xl pt-4">
            {t("page.preOrder.appreciate")}
          </div>
          <div className="mt-text-body-xl pt-4">
            <div>{t("page.preOrder.questions")}</div>
            <div className="pt-4">
              Email:{" "}
              <strong>
                <a href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</a>
              </strong>
            </div>{" "}
            <div className="pt-4">
              {t("contact.phoneNumber")}:{" "}
              <strong>
                <a href={`tel:${PHONE_NUMBER}`}>{DISPLAY_PHONE_NUMBER}</a>
              </strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
